import styled from '@emotion/styled';
import { QcsModalBox } from '../common/basic/QcsModalBox';
import { FC } from 'react';

export const QcsProtocolImg = styled.img(({ theme }) => ({
  maxWidth: '90vw',
  maxHeight: '90vh',
  width: 'auto',
  height: 'auto',
  display: 'block',
  [theme.breakpoints.up('md')]: {
    minHeight: '300px',
  },
}));

export const QcsProtocolIframe = styled.iframe(() => ({
  width: '95vw',
  height: '95vh',
  maxWidth: '90vw',
  maxHeight: '90vh',
  border: 'none',
  display: 'block',
  margin: '0 auto',
}));

export const QcsProtocolModalBox: FC<{
  disableBorder: boolean;
  children: React.ReactNode;
}> = ({ disableBorder, children }) => {
  return (
    <QcsModalBox
      sx={
        disableBorder
          ? {
              padding: 0,
              border: 'none',
              backgroundColor: 'transparent',
              minWidth: 'auto',
              width: 'fit-content',
              height: 'fit-content',
              maxWidth: '90vw',
              maxHeight: '90vh',
              overflow: 'visible',
            }
          : undefined
      }
    >
      {children}
    </QcsModalBox>
  );
};
